<template>
	<div>
		<div class="page">
			<Header/>
			<div class="page_content container-fluid">
				<router-view/>
			</div>
		</div>
		<Footer/>
	</div>
</template>
<script>
	import Header from 'components/Header'
	import Footer from 'components/Footer'
	export default {
		name: 'layout',
		components: {
			Header,
			Footer
		}
	}
</script>
